@use '@lib/assets/styles/main.scss' as *;
@use '@lib/components/Select/SelectExtends' as *;

.buttonActiveIcon {
  display: block;
  color: $blue500;
}

.container {
  position: relative;
}

.list {
  overflow: hidden;
  position: relative;
  border-top: 1px solid $gray200;
}

.listScroll {
  @include scrollStyles;
  overflow-y: auto;
  max-height: 255px;
}

.gradient {
  background: linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%);
  height: 40px;
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 2;
}

.item {
  @include dropDownItemStyle;
  position: relative;
  &.itemSelected {
    padding-right: 48px;
  }
  &.itemActive {
    background: $gray100;
  }
  &.itemWithLeftIcon {
    display: flex;
    gap: 12px
  }
}

.itemLeftIcon {
  color: $gray400;
}

.itemSelectedIcon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: $blue500;
}

.itemName {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px 8px 16px;
  flex: 1 0 0;
  align-self: stretch;
  border-top: 1px solid $gray200;
}
